/* Trade Engraving theme - global behaviour */
(function () {
  'use strict';

  // Mobile navigation drawer -------------------------------------------------
  const drawer = document.querySelector('[data-drawer]');
  const openBtn = document.querySelector('[data-drawer-open]');
  const closeEls = document.querySelectorAll('[data-drawer-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (openBtn) openBtn.addEventListener('click', () => setDrawer(true));
  closeEls.forEach((el) => el.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setDrawer(false);
  });

  // Reveal on scroll ---------------------------------------------------------
  const revealEls = document.querySelectorAll('[data-reveal]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (revealEls.length && 'IntersectionObserver' in window && !prefersReducedMotion) {
    document.documentElement.classList.add('js-reveal');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => revealObserver.observe(el));
  }

  // Product gallery ----------------------------------------------------------
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.getAttribute('data-full');
        if (mainImg && full) {
          mainImg.src = full;
          mainImg.srcset = '';
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  // Legacy product FAQs: upgrade expanded <dl class="pd-faq"> to <details> -----
  document.querySelectorAll('dl.pd-faq').forEach((dl) => {
    const items = [];
    let question = null;
    for (const child of Array.from(dl.children)) {
      if (child.tagName === 'DT') question = child;
      else if (child.tagName === 'DD' && question) {
        items.push({ q: question, a: child });
        question = null;
      }
    }
    if (!items.length) return;
    const wrap = document.createElement('div');
    wrap.className = 'pd-faq';
    items.forEach(({ q, a }) => {
      const details = document.createElement('details');
      details.className = 'pd-faq__item';
      const summary = document.createElement('summary');
      summary.className = 'pd-faq__q';
      summary.innerHTML = q.innerHTML;
      const body = document.createElement('div');
      body.className = 'pd-faq__a';
      body.innerHTML = a.innerHTML;
      details.append(summary, body);
      wrap.append(details);
    });
    dl.replaceWith(wrap);
  });

  // Cart: update quantity / remove ------------------------------------------
  async function updateCart(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (res.ok) window.location.reload();
  }
  document.querySelectorAll('[data-cart-remove]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      updateCart(Number(btn.getAttribute('data-line')), 0);
    });
  });
  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      updateCart(Number(input.getAttribute('data-line')), Number(input.value));
    });
  });

  // Trade account promo popup (one-time, delayed) ---------------------------
  const promo = document.querySelector('[data-trade-promo]');
  if (promo) {
    const storageKey = promo.getAttribute('data-storage-key') || 'te_trade_promo_dismissed';
    const delayMs = Math.max(0, Number(promo.getAttribute('data-delay')) || 20000);
    const dialog = promo.querySelector('[data-trade-promo-dialog]');
    let previouslyFocused = null;
    let openTimer = null;
    let opened = false;
    const armedAt = Date.now();

    function alreadyDismissed() {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (_) {
        return false;
      }
    }

    function rememberDismissed() {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (_) { /* private mode / blocked storage */ }
    }

    function getFocusable() {
      if (!dialog) return [];
      return Array.from(
        dialog.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => !el.hasAttribute('disabled') && el.offsetParent !== null);
    }

    function remainingMs() {
      return Math.max(0, delayMs - (Date.now() - armedAt));
    }

    function arm() {
      if (opened || alreadyDismissed()) return;
      if (openTimer) window.clearTimeout(openTimer);
      openTimer = window.setTimeout(openPromo, remainingMs());
    }

    function openPromo() {
      if (opened || alreadyDismissed() || promo.classList.contains('is-open')) return;
      opened = true;
      if (openTimer) window.clearTimeout(openTimer);
      previouslyFocused = document.activeElement;
      promo.hidden = false;
      promo.setAttribute('aria-hidden', 'false');
      // Force layout so the open transition runs
      void promo.offsetWidth;
      promo.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const focusable = getFocusable();
      (focusable[0] || dialog)?.focus();
    }

    function closePromo() {
      if (!promo.classList.contains('is-open') && promo.hidden) return;
      rememberDismissed();
      promo.classList.remove('is-open');
      promo.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      window.setTimeout(() => {
        promo.hidden = true;
      }, 280);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    if (!alreadyDismissed()) arm();

    // Phones drop the timer when the tab is backgrounded. Start it again,
    // counting from the original page load, when the page comes back.
    window.addEventListener('pageshow', arm);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) arm();
    });

    promo.querySelectorAll('[data-trade-promo-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closePromo();
      });
    });

    const cta = promo.querySelector('[data-trade-promo-cta]');
    if (cta) {
      cta.addEventListener('click', () => {
        rememberDismissed();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!promo.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closePromo();
        return;
      }
      if (e.key !== 'Tab' || !dialog) return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

  }
})();
